angular.module('leanlaw').controller('CodesBillablesDetailCtrl', ['$scope', '$rootScope', '$q', '$filter', '$timeout', '$stateParams', '$state', "alerts", 'userService', 'reportsService', 'commonFilterService', "exportJson", "singleRequest", "objectNumberManipulator", "messageBus", 'leanLawApi', function ($scope, $rootScope, $q, $filter, $timeout, $stateParams, $state, alerts, userService, reportsService, commonFilterService, exportJson, singleRequest, objectNumberManipulator, messageBus, leanLawApi) {
  $scope.clients = {};
  $scope.filter = {};
  $scope.search = "";
  $scope.format = {};
  $scope.sort = ['client.label', 'matter.label'];
  $scope.reverse = false;
  $scope.print = function () {
    window.print();
  };
  $scope.export = function () {
    const matter = $scope.me.terms.Matter;
    const exp = $scope.data.filteredClients.reduce((accum, c) => {
      accum.push({
        "Client": c.client.label || c.client.name,
        [matter]: "",
        "Billable hours": $filter("hoursDecimal")(c.data.hours.billable),
        "Non-billable hours": $filter("hoursDecimal")(c.data.hours.nonBillable),
        "Total hours": $filter("hoursDecimal")(c.data.hours.total),
        "Fixed fees": $filter("amount")(c.data.amounts.charges),
        "Expenses": $filter("amount")(c.data.amounts.expenses),
        "Total amount": $filter("amount")(c.data.amounts.total)
      });
      if ($scope.filter.include.matters) {
        c.matters.forEach(m => {
          accum.push({
            "Client": "",
            [matter]: m.matter.label || m.matter.name,
            "Billable hours": $filter("hoursDecimal")(m.data.hours.billable),
            "Non-billable hours": $filter("hoursDecimal")(m.data.hours.nonBillable),
            "Total hours": $filter("hoursDecimal")(m.data.hours.total),
            "Fixed fees": $filter("amount")(m.data.amounts.charges),
            "Expenses": $filter("amount")(m.data.amounts.expenses),
            "Total amount": $filter("amount")(m.data.amounts.total)
          });
        });
      }
      return accum;
    }, []);
    exportJson.downloadCsv(exp);
  };
  $scope.loading = true;
  userService.me().then(me => {
    $scope.trust = me.company.settings.trustEnabled;
    $scope.code = $stateParams.code;
    $scope.$on('commonFilterService-statechanged', (event, payload) => {
      if (!payload) return;
      // Assigning to existing filter keeps custom filter options
      $scope.filter = Object.assign($scope.filter, payload);
      // Necessary to set this value for the requests
      $scope.filter.status = $scope.filter.archived.status;
      $scope.filter.scope = $scope.filter.filter.scope;
      $scope.filter.billedState = $scope.filter.billedFilter && $scope.filter.billedFilter.id;

      // if (payload.filter.range) filterClientEntries();
      filterClientEntries();
    });
    $scope.$on("report-sidebar-filterchange", (event, payload) => {
      $scope.filter = Object.assign($scope.filter, payload);
    });
    $scope.$watch('filter.include.accounting', show => {
      if (show) {
        filterClientEntries();
      }
    }, true);

    // MessageBus is used here so that the commonFilter module can pick it up once it loads
    messageBus.addMessage("filterDependency-ready", true);
  });
  function filterClientEntries() {
    $scope.loading = true;
    var query = angular.copy($scope.filter);
    query.code = $stateParams.code;
    query.data = "services,expenses,charges,hours";
    singleRequest.serviceCall("clientEntries", reportsService.getClientReport)(query).then(data => {
      if (!data) return;
      $scope.data = data;
      $scope.loading = false;
    }).catch(err => {
      $scope.loading = false;
      alerts.error(err);
    });
  }
  const deactivate = $rootScope.$on('$stateChangeStart', () => {
    singleRequest.cancel("clientEntries");
    deactivate();
  });
  $scope.$watch("search", () => {
    if (!$scope.data || !$scope.data.filteredClients) return; // Not loaded yet

    // Wait for DOM update because filteredClients is updated there
    $timeout(() => {
      // Reset total
      objectNumberManipulator.resetValues($scope.data.data);
      // Update sums
      $scope.data.filteredClients.forEach(fc => {
        objectNumberManipulator.sumValues($scope.data.data, fc.data);
      });
    });
  });
}]);